export const AMMINISTRATORE = 'A';
export const LAVORATORE = 'L';
export const AMMINISTRATORE_ENTE = 'AE';
export const OPERATORE_ENTE = 'E';
export const CITTADINO = 'C';
export const ADMIN_PREFIX = '/admin/';
export const ENTE_PREFIX = '/e/';

//description AMMINISTRATORE
export const DESCRIPTION_PROFILE_AMMINISTRATORE = "Amministratore WeMi";